import * as PIXI from "pixi.js";
import { TestDisplayLandscapeProperties } from "../landscape/TestDisplayLandscapeProperties";
import { GridLayout } from "@lib/titan2/dist/game/control/layout/GridLayout";
/**
 * TestDisplayPortraitProperties.ts
 */
export class TestDisplayPortraitProperties extends TestDisplayLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.testButtonProperties.textFieldProperties.size = new PIXI.Point(150, 30);
        this.position.y += 20;
        this.panelProperties.layout = new GridLayout(99, 5, 5, 5);
    }
}
